import css from 'styled-jsx/css';
import { icons, colors } from '../../../config/styles';
import { svgReplaceColor, svgToDataUri } from '../../../utils/styles/svgMixins';

const RelatedKeywordsPodStyles = css`
  .related-keyword-pod {
    box-sizing: border-box;
    padding: 0 12px 0 2px;
    height: 30px;
    background-color: ${colors.white.shade1};
    border: 1px solid #a9b5c0;
    border-radius: 8px;
    display: inline-flex;
    text-decoration: none;
    margin-right: 8px;

    .related-keyword-pod-icon {
      width: 16.47px;
      height: 16.47px;
      margin: 7px 6.53px 0 7px;
      background: url('${svgToDataUri(svgReplaceColor(icons.search, colors.socialIcons.email))}');
    }

    .related-keyword-pod-text {
      height: 14px;
      font-weight: 700;
      font-size: 12px;
      line-height: 14px;
      color: ${colors.black.shade10};
      margin-top: 8px;
      white-space: nowrap;
    }
  }
`;

export { RelatedKeywordsPodStyles };
